import "./component.scss";




// WEBPACK FOOTER //
// ./app/components/swiper/component.js